import ExistValueService from 'src/services/validation/validators/ExistValue';
import BirthDateService from 'src/services/validation/validators/BirthDate';
import NifExpirationService from 'src/services/validation/validators/NifExpiration';
import { Validation } from 'src/services/validation/Validator';
import validationMessages from 'src/stubs/validationMessages';
import EmailService from './validators/Email';
import IBANService from './validators/IBAN';
import AmountInvestedService from 'src/services/validation/validators/AmountInvested';
import FileSizeService from 'src/services/validation/validators/FileSize';

interface BackendErrors {
  [key: string]: string[];
}

class ValidatorServiceSingleton {
  private static _instance: ValidatorServiceSingleton;

  public readonly exists: ExistValueService;
  public readonly birthDate: BirthDateService;
  public readonly nifExpiration: NifExpirationService;
  public readonly email: EmailService;
  public readonly iban: IBANService;
  public readonly amountInvested: AmountInvestedService;
  public readonly fileSize: FileSizeService;

  public validate(validations: Validation[]): Promise<void> {
    const reflect = (promise: Promise<void>) => promise.then(
      () => ({ status: 'success' }),
      (error: string) => ({ payload: error, status: 'failure' })
    );

    const validationPromises = validations.map(validation => {
      return this[validation.type || 'exists'].getValidation(validation.value, validation.message);
    });
    return Promise.all(validationPromises.map(reflect)).then(
      (responses: { payload: string, status: string }[]) => {
        if (responses.every(response => response.status === 'success')) {
          return;
        } else {
          const errors = {};
          responses.filter(r => r.status === 'failure').map(r => r.payload).forEach((error: string) => {
            errors[error] = validationMessages[error];
          });

          throw errors;
        }
      },
    );
  }

  public translateValidations(backendErrors: BackendErrors = {serverConnection: ['serverConnection']}) {
    if (!backendErrors) {
      return {};
    }

    if (typeof backendErrors === 'string') {
      return {[backendErrors]: validationMessages[backendErrors]};
    }

    const errors = {};
    const errorKeys = Object.keys(backendErrors);

    errorKeys.forEach((key) => {
      backendErrors[key].forEach((r: string) => {
        errors[r] = validationMessages[r];
      });
    }
    );

    return errors;
  }

  public static get instance(): ValidatorServiceSingleton {
    return this._instance || (this._instance = new this());
  }

  private constructor() {
    this.exists = new ExistValueService();
    this.birthDate = new BirthDateService();
    this.nifExpiration = new NifExpirationService();
    this.email = new EmailService();
    this.iban = new IBANService();
    this.amountInvested = new AmountInvestedService();
    this.fileSize = new FileSizeService();
  }
}

const ValidatorService: ValidatorServiceSingleton = ValidatorServiceSingleton.instance;

export default ValidatorService;


// WEBPACK FOOTER //
// ./src/services/validation/Validation.service.tsx